import React, { useState } from 'react'
import NotificationIcon from "../../../../styles/img/svg/NotificationIcon"
import PropTypes from 'prop-types';
import { UiProfileInfo } from './UiProfileInfo';

export default function UiTopNavProfile(props) {

    const [showProfileMenu, setShowProfileMenu] = useState(false);

    const showProfile = () => {
        setShowProfileMenu(!showProfileMenu)
    }


    return (
        <>
            <div className='sb-top-nav-wr__profile-area'>
                <div className='sb-top-nav-wr__notification'>
                    <NotificationIcon />
                </div>
                <div className='sb-top-nav-wr__profile' onClick={showProfile}>
                    <div className='sb-top-profile'>
                        <div className='sb-top-profile__img'>
                            <img src={props.profileImg} alt="profile-img" />
                        </div>
                        <div className='sb-top-profile__right-wr'>
                            <div className='sb-top-profile__name'>
                                <h5>{props.name}</h5>
                            </div>
                            <div className='sb-top-profile__points'>
                                <h5>{props.points}</h5>
                                <span>Points</span>
                            </div>
                        </div>
                    </div>
                </div>


                <div className={showProfileMenu ? 'sb-top-nav-wr__profile-expanded show-profile-div' : 'sb-top-nav-wr__profile-expanded'}>
                    <UiProfileInfo />
                </div>


            </div>
        </>
    )

}
UiTopNavProfile.propTypes = {
    profileImg: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    points: PropTypes.string,
};